import React from "react";
import LegalPageShell from "@/components/LegalPageShell";

const CookiePolicy = () => (
  <LegalPageShell
    dictionaryKey="cookies"
    testid="cookies-page"
    sectionKeys={["what", "types", "consent", "manage", "contact"]}
  />
);

export default CookiePolicy;
